import { HomeHero } from "@/components/home/HomeHero";
import { StepsSection } from "@/components/home/StepsSection";
import { JourneyPreview } from "@/components/home/JourneyPreview";
import { GuidePreview } from "@/components/home/GuidePreview";
import { Marquee } from "@/components/site/Marquee";
import { HomeInvitation } from "@/components/home/HomeInvitation";
import { CoachingSection } from "@/components/home/CoachingSection";
import { Testimonials } from "@/components/home/Testimonials";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HomeHero />
      <Marquee />
      <StepsSection />
      <CoachingSection />
      <JourneyPreview />
      <GuidePreview />
      <Testimonials />
      <HomeInvitation />
    </div>
  );
}
